<template><div class="fill-place">
    <div @click.stop.prevent="fill_click" class="person-info">
        <div class="person-info__content" :class="{_error: shouldShowError}">
            <div class="person-info__booking">               
                {{place_label}}
            </div>
            <div class="person-info__service-icon">
                <vWarning v-if="shouldShowError" class="icon vicon-orange"/>
            </div>
        
            <div class="person-info__name">
                {{person_names.fio}}
            </div>
            <div class="person-info__sign" v-if="person_names.born || person_names.male">
                {{person_names.born}}{{ person_names.born ? ', ' : ''}}{{person_names.male}}
            </div>
            <div class="person-info__docs" v-if="person_names.doc_type || person_names.doc_num">
                <div class="person-info__docs-icon">
                    <component :is="docIcon" />
                </div>
                <div class="person-info__docs-type">{{person_names.doc_type}}</div>
                <div class="person-info__docs-num"  v-if="person_names.doc_num">{{person_names.doc_num}}</div>
            </div>
        </div>
        <div class="person-info__errors" v-if="shouldShowError">
            {{person_names.isValid ? 'Корректно' : 'Необходимо заполнить всю информацию'}}
        </div>
    </div>

    <template v-if="wasClick">
        <Modal v-model="isModalShown"
            :enableClose="false"
            title=""
            modal-class="fill-modal"
            wrapper-class="animate__animated"
            in-class="animate__zoomIn hideScroll"
            out-class="animate__zoomOut hideScroll">
            <div class="fill-modal__header fill-modal-header">
                <ModalTitle class="fill-modal-header__title" @close="close_click">
                    {{ ModalTitleName }} <span class="fill-modal-header__id">{{personItem.sid}}</span>
                </ModalTitle>
                <div class="fill-modal-header__content">
                    Пожалуйста, заполните все поля
                </div>
            </div>

            <div class="fill-modal__content" ref="personRef">
                <Person :sid="personItem.sid" :copy_person_list="copy_person_list" :copy_person_button="isCustomer() ? 'Сделать заказчиком' : 'Внести данные' " />
            </div>

            <div class="fill-modal__footer fill-modal-footer">
                <div class="fill-modal-footer__info">
                    <PersonEmptyFields :sid="personItem.sid" :personRef="personRef" class="fill-modal-footer__empty"/>
                    <button class="fill-modal-footer__clear-all" @click.stop.prevent="clear_all">Очистить форму</button>
                </div>
                <div class="fill-modal-footer__controls">
                    <button @click.stop.prevent="close_click" class="btn btn--bluefigma">Сохранить данные</button>
                </div>
            </div>
        </Modal>
    </template>

</div></template>

<style lang="scss" src="./FillPlace.scss"></style>

<script setup>
import {ref, unref, computed, onMounted, watch, nextTick} from 'vue'
import useCabinsStore from '@/bookCabins.js'
import useTouristStore,{ttname_by_id,SID_CUSTOMER} from '@/tourist/tourist-store.js'
import {dmy2ymd, getEarlierSids, fio_person} from '@/comp/useOrder.js'
import Person from '@/tourist/PersonForm.vue'
import PersonEmptyFields from '@/tourist/PersonEmptyFields.vue'
import ModalTitle from '@/comp/ModalTitle/ModalTitle.vue'
import Modal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import 'animate.css'
import vWarning from '@/assets/vicons/seal-warning.vue'

import vEmblem from '@/assets/vicons/emblem_russia.vue'
import vChild from '@/assets/vicons/child.vue'
import vPlanet from '@/assets/vicons/planet.vue'
import vIdentificationCard from '@/assets/vicons/identification-card.vue'

const docIconMap = {
  ps: vEmblem,
  zps: vPlanet,
  svr: vChild,
  other: vIdentificationCard,
}

const docIcon = computed(() => {
    const {doc_id} = unref(person_names)
    return docIconMap[ doc_id ] || vEmblem
})

const bookCabins = useCabinsStore()
const tstore = useTouristStore()

const props = defineProps({
    place: Object,
    cabinId: Number,
    Cabin: Object,
    ages: Object,
})
const emits = defineEmits( ['close'] )

const personItem = bookCabins.personItem( props.cabinId, props.place)

const isModalShown=ref(false)
const wasClick = ref(false) // чтобы modal в vue дереве
const personRef = ref(false)
const showErrors = ref(false)

const shouldShowError = computed(() => {
    let ret = !person_names.value.isValid
    const sid = unref(personItem).sid
    if (!sid || !tstore.wasTouched( sid )) {
        ret = false
    }

    return ret
})

const place_label = computed(() => {
    const cabinId = props.cabinId

    if (cabinId === bookCabins.customerCabinId) {
        return 'Заказчик; Взрослый'
    }

    const {pnum} = props.place
    let placeStr
    let typeStr

    if (pnum >= 0) {
        placeStr = `Место ${pnum + 1}`
        if (props.place.ttype === 'cr-adult') {
            typeStr = 'Взрослый'
        } else {
            const {since, till} = props.ages.child
            typeStr = `Ребенок ${since}–${till - 1}.99`
        }
    } else {
        placeStr = 'Инфант'
        const {since, till} = props.ages.infant
        typeStr = `${since}–${till - 1}.99`
    }

    return `${placeStr}; ${typeStr}`
})

const copy_person_list = computed(() => {
    let ret = []
    const sid = unref(personItem).sid
    if (sid === SID_CUSTOMER) {
        ret = bookCabins.getAdultSids()
    } else {
        ret = getEarlierSids(tstore, bookCabins)
    }
    ret = ret.map( id => {
        let name = fio_person(tstore.person(id), false) // полностью
        return {id, name}
    } ).filter( ({name})=>Boolean(name) )
    return ret
})

const isCustomer = () => {
    const sid = unref(personItem).sid
    return Boolean(sid === SID_CUSTOMER)
}

const fill_click = () => {
    wasClick.value = true
    isModalShown.value = true
    if (!unref(personItem).sid) {
        if (props.cabinId === bookCabins.customerCabinId) {
            personItem.value = SID_CUSTOMER
        } else {
            personItem.value = tstore.add_person( props.place.itype )
        }
    }
}

const close_click = () => {
    showErrors.value = true
    isModalShown.value = false
    emits('close')
}

const place_num = ({pnum}, cabinId) => {
    let ret
    if (cabinId === bookCabins.customerCabinId) {
        ret = 'Заказчик'
    } else {
        ret = pnum >= 0 ? `Место ${pnum+1}` : 'Инфант'
    }
    return ret
} 

const ModalTitleName = computed(() => {
    let ret
    const cabinId = props.cabinId
    if (cabinId === bookCabins.customerCabinId) {
        ret = 'Заказчик; Взрослый'
    } else {
        const {pnum} = props.place
        if (pnum>=0) {
            let dop = ''
            if (props.place.ttype === 'cr-adult') {
                dop = 'Взрослый'
            } else {
                let {since,till} = props.ages.child
                dop = `Ребенок ${since} - ${till-1}.99`
            }
            ret =  `Место ${pnum+1}; ${dop}`
        }else{
            let {since,till} = props.ages.infant
            ret = `Инфант ${since} - ${till-1}.99`
        }
        ret = `Каюта ${props.Cabin.name}; ${ret}`
    }
    return ret
})

const person_names = computed(() => {
    const {sid, itype} = unref(personItem)
    const itype_name = ttname_by_id( itype )

    let fio = ''
    let born = ''
    let male = ''
    let doc_type = ''
    let doc_id = ''
    let doc_num = ''
    let isValid = false
    let hasAnyValue = false

    if (sid) {
        const person = tstore.person(sid)

        fio = fio_person(person, true)
        born = person.born.val && person.vest.isValid ? person.born.val  : ''

        let m = person.male.options.find(ob => ob.id === person.male.val)
        male = m && person.male.val ? m.name.toLowerCase() : ''

        let d = person.doc_type.options.find(ob => ob.id === person.doc_type.val)
        doc_type = d && person.doc_type.val ? d.name : ''
        doc_id = person.doc_type.val

        doc_num = `${person.doc_serie.val} ${person.doc_number.val}`.trim()

        isValid = person.vest.isValid

        hasAnyValue =
            person.fname.val ||
            person.iname.val ||
            person.oname.val ||
            person.born.val ||
            person.male.val ||
            person.doc_type.val ||
            person.doc_serie.val ||
            person.doc_number.val
    }

    return {
        itype_name,
        fio,
        born,
        male,
        doc_type,
        doc_id,
        doc_num,
        isValid,
        hasAnyValue,
    }
})

const clear_all = () => {
    const { sid } = unref(personItem)
    if (!sid) return

    tstore.clear_person(sid)
}

</script>
